import { FvButton } from '@fv/client-components'

import { useRetractTender } from '@/hooks/shipments/useRetractTender'

import { ListSubActions, ListSubContainer } from './ListSubContainer'

type Props = {
  loadId: string
}

export const RetractTenderForm = ({ loadId }: Props) => {
  const retract = useRetractTender()
  const onClick = () => {
    if (!retract.confirm()) {
      return
    }

    retract.mutate(loadId)
  }

  return (
    <ListSubContainer className="!pb-0">
      <ListSubActions justify="start">
        <FvButton
          loading={retract.isPending}
          icon="undo"
          onClick={() => onClick()}
          theme="default"
        >
          Retract tender
        </FvButton>
      </ListSubActions>
    </ListSubContainer>
  )
}
